const MODULE_NAME = 'PATIENT_MEASUREMENT_DRUG_INTAKES';
const PATIENT_DRUG_INTAKES_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const PATIENT_DRUG_INTAKES_FETCH_ERROR = MODULE_NAME + 'FETCH_ERROR';
const PATIENT_MEASUREMENT_DRUG_INTAKES_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const PATIENT_DRUG_INTAKES_CLEAR = MODULE_NAME + 'CLEAR';

export {
  PATIENT_MEASUREMENT_DRUG_INTAKES_FETCH_COMPLETED,
  PATIENT_DRUG_INTAKES_FETCH_STARTED,
  PATIENT_DRUG_INTAKES_FETCH_ERROR,
  PATIENT_DRUG_INTAKES_CLEAR
};
